import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Update this path as needed

const DestinationTypes = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedDestination, setSelectedDestination] = useState(null);

  const [destinationTypes, setDestinationTypes] = useState([
    { id: 1, type: "Religious", status: "Active" },
    { id: 2, type: "Nature", status: "Active" },
    { id: 3, type: "Historical", status: "Inactive" },
    { id: 4, type: "Adventure", status: "Active" },
    { id: 5, type: "Heritage", status: "Inactive" },
    { id: 6, type: "Animal", status: "Active" },
    { id: 7, type: "Urban", status: "Active" },
    { id: 8, type: "Train", status: "Inactive" },
    { id: 9, type: "Sea", status: "Active" },
    { id: 10, type: "Entertaining", status: "Active" },
    { id: 11, type: "Classical", status: "Inactive" },
  ]);

  const [formData, setFormData] = useState({
    type: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [destinationTypes]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedDestination) {
      setDestinationTypes(
        destinationTypes.map((d) =>
          d.id === selectedDestination.id ? { ...formData, id: d.id } : d
        )
      );
    } else {
      const newId = destinationTypes.length
        ? destinationTypes[destinationTypes.length - 1].id + 1
        : 1;
      setDestinationTypes([...destinationTypes, { ...formData, id: newId }]);
    }
    setShowForm(false);
    setFormData({ type: "", status: "Active" });
    setSelectedDestination(null);
  };

  const handleEdit = (destination) => {
    setSelectedDestination(destination);
    setFormData({ type: destination.type, status: destination.status });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedDestination(null);
    setFormData({ type: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="destination-type-list d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "300px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedDestination ? "Edit Destination Type" : "Add Destination Type"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Destination Type:</label>
              <input
                type="text"
                name="type"
                value={formData.type}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>Destination Types</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Destination Type
            </button>
          </div>
          <div className="card-body">
            <table ref={tableRef} className="table table-bordered display" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Destination Type</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {destinationTypes.map((destination) => (
                  <tr key={destination.id}>
                    <td>{destination.type}</td>
                    <td>
                      <span className={`badge ${destination.status === "Active" ? "bg-success" : "bg-danger"}`}>
                        {destination.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(destination)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DestinationTypes;
